// Styling comes from the employees page - to be refactored to tailwind in both places
import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { useQuery } from '@tanstack/react-query'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import queries from '@/modules/admin/queries'
import adminResources from '@/modules/admin/resources'

import { AssetListItem } from './AssetListItem'

export const AssetsSneakPeek: FC<{ assetLocationId: number; onGoToAssetTab: () => void }> = ({
  assetLocationId,
}) => {
  const [, setQueryTab] = useSearchParamsByKey('tab')

  const { data: assetsData, isLoading } = useQuery(
    queries.adminAssetList({ allAssets: true }),
    () => adminResources.getAssetListWithFilters({ allAssets: true })
  )

  if (!assetsData) return null

  const itemsFiltered =
    assetsData?.assets.filter(asset => asset.costObjectId === Number(assetLocationId)) || []

  const shortenedList = itemsFiltered.slice(0, 2)
  const numberOfRemainingAssets = itemsFiltered.length - 2

  if (isLoading) return <LoaderCircle />

  return (
    <div className="profile-assets">
      <h3>
        <Translation id="Assets" />
      </h3>

      {shortenedList.length > 0 ? (
        <div className="sneak-peek-asset-list">
          {shortenedList.map(item => (
            <AssetListItem key={item.id} searchFilter="" {...item} />
          ))}

          {numberOfRemainingAssets > 0 && (
            <div className="remaining-assets">
              <Button variant="tertiary" className="m-0 p-0" onClick={() => setQueryTab('assets')}>
                <div className="more-assets">
                  <div>
                    <Translation
                      id="{numberOfRemainingAssets} more"
                      numberOfRemainingAssets={String(numberOfRemainingAssets)}
                      className="more-assets-text"
                    />
                  </div>
                  <div>
                    <ChevronRightIcon />
                  </div>
                </div>
              </Button>
            </div>
          )}
        </div>
      ) : (
        <NoResults />
      )}
    </div>
  )
}
